import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Founder() {
  return <section className="py-16 lg:py-20 bg-cream-dark" data-id="element-74">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-75">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-76">
          {/* Text — Left Side */}
          <div data-id="element-77">
            <FadeIn data-id="element-78">
              <h2 className="text-4xl md:text-5xl font-bold mb-8 text-navy" data-id="element-79">
                Meet the Founder
              </h2>
            </FadeIn>

            <div className="space-y-5 text-lg text-body leading-relaxed" data-id="element-80">
              <FadeIn delay={0.1} data-id="element-81">
                <p className="font-serif text-2xl text-charcoal italic" data-id="element-82">
                  Hi, I'm Stephanie Martin.
                </p>
                <p className="text-navy font-medium mt-2 uppercase tracking-wide text-sm" data-id="element-83">
                  Founder, strategist, and builder behind LeadHerShip Equity.
                </p>
              </FadeIn>

              <FadeIn delay={0.2} data-id="element-84">
                <p data-id="element-85">
                  I didn't build my businesses by chasing trends or posting
                  endlessly online.
                </p>
                <p className="mt-3" data-id="element-86">
                  I built them by learning how to turn expertise into structured
                  offers that actually generate revenue.
                </p>
              </FadeIn>

              <FadeIn delay={0.3} data-id="element-87">
                <p data-id="element-88">
                  LeadHerShip Equity exists because I watched too many women
                  stay stuck in survival mode — constantly creating, constantly
                  posting — but never building something that pays them
                  consistently.
                </p>
              </FadeIn>

              <FadeIn delay={0.4} data-id="element-89">
                <p data-id="element-90">
                  Inside this masterclass, I'm going to show you the exact
                  framework I use to help women move from scattered income to
                  aligned, scalable income.
                </p>
              </FadeIn>

              <FadeIn delay={0.5} className="pt-5 border-t border-cream-dark mt-6" data-id="element-91">
                <p className="font-serif text-xl text-charcoal font-medium" data-id="element-92">
                  If you're ready to build something sustainable, you're in the
                  right room.
                </p>
              </FadeIn>
            </div>
          </div>

          {/* Polaroid — Right Side */}
          <FadeIn delay={0.2} direction="left" className="relative h-[500px] md:h-[550px] flex items-center justify-center" data-id="element-93">
            <div className="w-72 md:w-80 bg-white p-3 md:p-4 pb-16 md:pb-20 shadow-2xl transform -rotate-2 border border-gray-200" data-id="element-94">
              <div className="aspect-[3/4] bg-gray-200 overflow-hidden" data-id="element-95">
                <img src="https://cdn.magicpatterns.com/uploads/5RFsyV3GCruPVHnYW1jQux/IMG_5943.png" alt="Stephanie Martin, Founder of LeadHerShip Equity" className="w-full h-full object-cover" data-id="element-96" />
              </div>
              <div className="absolute bottom-4 md:bottom-6 left-0 right-0 text-center font-serif text-xl md:text-2xl text-navy italic" data-id="element-97">
                Stephanie
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}